import { api } from '../api/index.js'

export const presenceService = {
  async sendHeartbeat(): Promise<void> {
    await api.post({}, '/v1/heartbeat').res()
  },
}
